module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-indicator"
  }, [_c('div', {
    ref: "currentSlide",
    staticClass: "slide-indicator__current-slide"
  }, [_vm._v(_vm._s(_vm.currentSlideId + 1))]), _vm._v(" "), _c('div', {
    ref: "separator",
    staticClass: "slide-indicator__separator"
  }), _vm._v(" "), _c('div', {
    ref: "sliderLength",
    staticClass: "slide-indicator__slider-length"
  }, [_vm._v(_vm._s(_vm.sliderLength))]), _vm._v(" "), _c('div', {
    ref: "sliderName",
    staticClass: "slide-indicator__slider-name"
  }, [_vm._v(_vm._s(_vm.sliderName))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c9fa241!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/Slider/SlideIndicator.vue
// module id = 274
// module chunks = 0